import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import moment from 'moment';
import numeral from 'numeral';
import { S3Image } from '../../lib/s3';
import { bgColorForName } from '../../lib/findBobUtils';

class CurrentPipelineActivityCard extends React.Component {
  getAvatar = () => {
    const { classes } = this.props;
    return (
      <div>
        <Avatar size="24" className={classes.avatar} style={{ backgroundColor: bgColorForName(inventoryUser.name) }}>
          <i class="material-icons">attach_money</i>
        </Avatar>
      </div>
    );
  };

  clickName = () => {
    const { pipeline } = this.props;
    window.open(`/admin/inventory_users?inv_user=${pipeline.agent_iu_id}`, '_self');
  };

  clickPipeline = () => {
    const { pipeline } = this.props;
    window.open(`/admin/pipelines/${pipeline.pipeline_id}?card_id=${pipeline.id}`, '_self');
  };

  formatDate = date => {
    const today = moment().format('YYYYMMDD');
    if (today === moment(date).format('YYYYMMDD')) {
      return `Today at ${moment(date).format('LT')}`;
    }
    return `${moment(date).format('MMM D')} at ${moment(date).format('LT')}`;
  };

  renderDaysAgo = date => {
    if (date && moment().diff(moment(date), 'days') > 3) {
      return <span style={{ color: 'red' }}>{moment(date).fromNow(true).replace('a ', '1 ')} inactive</span>;
    }
    if (date && moment().diff(moment(date), 'days') > 3) {
      return <span>{moment(date).fromNow(true).replace('a ', '1 ')} inactive</span>;
    }
    return <span>No activities</span>;
  };

  render () {
    const { classes, pipeline } = this.props;
    return (
      <div className={classes.box}>
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <Avatar className={classes.avatar}>
              <i class="material-icons">attach_money</i>
            </Avatar>
          </Grid>
          <Grid item xs={10}>
            <div className={classes.contentBox}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <button type="button" className={classes.button} onClick={() => this.clickPipeline()}>
                    <div className={classes.title}>{decodeURI(pipeline.name)}</div>
                  </button>
                </Grid>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <span className={classes.content}>{numeral(pipeline.value).format('$0,0')} | </span>
                      <span className={classes.content}>{decodeURI(pipeline.stage_name)} | </span>
                      <span className={classes.content}>{this.renderDaysAgo(pipeline.inactive_days)}</span>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

CurrentPipelineActivityCard.propTypes = {
  classes   : PropTypes.object.isRequired,
  event     : PropTypes.object.isRequired,
  firstName : PropTypes.string.isRequired,
  initials  : PropTypes.string.isRequired,
  date      : PropTypes.string.isRequired,
  note      : PropTypes.string.isRequired,
  activity  : PropTypes.string.isRequired,
};

const styles = {
  box           : {
    marginTop : 5,
  },
  button        : {
    width      : '100%',
    height     : 'auto',
    padding    : 0,
    border     : 'none',
    background : 'none',
  },
  contentButton : {
    height     : 'auto',
    padding    : 0,
    border     : 'none',
    background : 'none',
    fontSize   : '1em',
  },
  title         : {
    textAlign  : 'left',
    fontWeight : 'bold',
  },
  event         : {
    textAlign : 'left',
    color     : '#0052CC',
  },
  contentBox    : {
    margin : '5px 0px 5px 5px',
  },
  content       : {
    textAlign : 'left',
    color     : '#808080',
    fontSize  : '1em',
  },
  contentName   : {
    textAlign      : 'left',
    color          : '#0052CC',
    fontSize       : '0.9em',
    textDecoration : 'underline',
    fontWeight     : 'bold',
  },
  note          : {
    textAlign    : 'left',
    fontSize     : 16,
    color        : '#000',
    marginTop    : 8,
    marginBottom : 10,
  },
  avatar        : {
    margin : '5px 10px 0px 15px',
  },
  avatarText    : {
    textTransform : 'uppercase',
  },
};

export default withStyles(styles)(CurrentPipelineActivityCard);

// <button type="button" className={classes.box} onClick={() => this.clickName()}>
